import React, { forwardRef } from 'react'
import { cname } from '../../bs-ui/utils'
import { ReactComponent as Load } from './Load.svg'

export const LoadIcon = forwardRef<SVGSVGElement & { className: any }, React.PropsWithChildren<{ className?: string }>>(
  ({ className, ...props }, ref) => {
    return <Load ref={ref} {...props} className={cname('animate-spin text-gray-50', className)} />
  }
)
